import { render } from "./ThePreloader.vue?vue&type=template&id=b243a66a&scoped=true&ts=true"
import script from "./ThePreloader.vue?vue&type=script&lang=ts"
export * from "./ThePreloader.vue?vue&type=script&lang=ts"

import "./ThePreloader.vue?vue&type=style&index=0&id=b243a66a&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b243a66a"]])

export default __exports__